module.exports = "<span class=\"arrow icon-arrow-down\" v-on:click=\"onClick\"></span>";


//////////////////
// WEBPACK FOOTER
// ./src/js/components/arrow/index.html
// module id = Oodw
// module chunks = 1